import { render } from "./EditFull.vue?vue&type=template&id=6c630a44&scoped=true"
import script from "./EditFull.vue?vue&type=script&lang=js"
export * from "./EditFull.vue?vue&type=script&lang=js"

import "./EditFull.vue?vue&type=style&index=0&id=6c630a44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c630a44"]])

export default __exports__